import css from '@styled-system/css';
import variant from '@styled-system/variant';
import { ThemeStyles } from '@honda-canada/design-system-react';

import { VARIANT1, VARIANT2, VARIANT3, VARIANT4 } from './constants';

const themeStyles = new ThemeStyles();

const navigationAndProgressBarHeight = '90px';

const BEFORE_ELEMENT_CLASS = {
  '@media screen and (min-width: 1280px)': {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: '-100vw',
      width: '100vw',
      background: 'linear-gradient(180deg, #EAEAEA 0%, #FFFFFF 100%)',
    },
  },
};

const AFTER_ELEMENT_BASE_STYLES = {
  content: '""',
  position: 'absolute',
  top: 0,
  bottom: 0,
  background: 'linear-gradient(180deg, #EAEAEA 0%, #FFFFFF 100%)',
};

themeStyles.addBaseStyles('Wrapper')(({ showDrawer }) =>
  css({
    display: 'flex',
    '@media screen and (max-width: 1023px)': {
      flexDirection: 'column',
      position: 'relative',
      minHeight: showDrawer && [
        `calc(100vh - ${navigationAndProgressBarHeight})`,
        `calc(100vh - ${navigationAndProgressBarHeight})`,
        'none',
      ],
      height: showDrawer && ['100%', '100%', 'none'],
    },
    maxWidth: '1280px',
    margin: '0 auto',
    pb: ['zero', 'zero', '40px'],
  }),
);

// left sidebar
themeStyles.addBaseStyles('Main')(
  ({ theme, showDrawer }) =>
    css({
      zIndex: 2,
      position: 'relative',
      height: showDrawer && [
        `calc((100vh - ${navigationAndProgressBarHeight})/2)`,
        `calc((100vh - ${navigationAndProgressBarHeight})/2)`,
        'auto',
      ],
      [`@media screen and (min-width:${theme.breakpoints[1]})`]: {
        flex: '2 1 0',
        display: 'flex',
      },
    }),
  variant({
    prop: 'variant',
    variants: {
      [VARIANT1]: {
        background: 'linear-gradient(180deg, #EAEAEA 0%, #FFFFFF 100%)',
        '& div.sticky-inner-wrapper > div': {
          background: 'transparent',
        },
        ...BEFORE_ELEMENT_CLASS,
      },
      [VARIANT2]: {
        background: 'linear-gradient(180deg, #EAEAEA 0%, #FFFFFF 100%)',
        '& div.sticky-inner-wrapper > div': {
          background: 'transparent',
        },
        width: '100%',
        ...BEFORE_ELEMENT_CLASS,
      },
      [VARIANT3]: {
        backgroundColor: 'white',
        '& div.sticky-inner-wrapper > div': {
          backgroundColor: 'white',
        },
      },
      [VARIANT4]: {
        backgroundColor: 'white',
        '& div.sticky-inner-wrapper > div': {
          backgroundColor: 'white',
        },
        width: '100%',
      },
    },
  }),
);

// right sidebar
themeStyles.addBaseStyles('Sidebar')(
  css({
    backgroundColor: 'white',
    flex: '1 1 0',
  }),
  ({ rightSideBarPseudoWidth }) => {
    const bg1 = 'linear-gradient(180deg, #EAEAEA 0%, #FFFFFF 100%)';
    const bg2 = 'linear-gradient(180deg, #FFF -29.59%, #EAEAEA 100%)';
    return variant({
      prop: 'variant',
      variants: {
        [VARIANT1]: {
          background: bg1,
          '&:has([data-component-name="BapSummaryCard"])': {
            background: [bg2, bg1, bg1],
          },
          '@media screen and (min-width: 1280px)': {
            position: 'relative',
            '&::after': {
              right: `-${rightSideBarPseudoWidth}px`,
              width: `${rightSideBarPseudoWidth}px`,
              ...AFTER_ELEMENT_BASE_STYLES,
            },
          },
        },
        [VARIANT2]: {
          background: bg1,
          '&:has([data-component-name="BapSummaryCard"])': {
            background: [bg2, bg1, bg1],
          },

          '@media screen and (min-width: 1280px)': {
            position: 'relative',
            '&::after': {
              right: `-${rightSideBarPseudoWidth}px`,
              width: `${rightSideBarPseudoWidth}px`,
              ...AFTER_ELEMENT_BASE_STYLES,
            },
          },
        },
        [VARIANT3]: {},
        [VARIANT4]: {
          width: '100%',
        },
      },
    });
  },
);

themeStyles.addBaseStyles('MainContent')(({ theme }) =>
  css({
    [`@media screen and (min-width:${theme.breakpoints[1]})`]: {
      maxWidth: '1110px',
      width: '100%',
    },
    zIndex: 2,
  }),
);

themeStyles.addBaseStyles('SidebarContent')(
  () =>
    css({
      zIndex: 2,
    }),
  // TODO: consider removing `SidebarContent` from the render tree. It obstructs to several styles
  variant({
    prop: 'variant',
    variants: {
      [VARIANT1]: {
        display: 'contents',
      },
      [VARIANT2]: {
        display: 'contents',
      },
    },
  }),
);

export default themeStyles;
